import { Actions, createEffect, ofType } from '@ngrx/effects';
import { iif, Observable, of, take } from 'rxjs';
import { switchMap, catchError, map } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';
import { Injectable } from '@angular/core';

import {
  fetchFlightsOptionForPackageUpsellAction, fetchFlightsOptionForPackageUpsellForDesktopAction, fetchOptionForUpsellAction,
  fetchPackageUpsellOptionsAction, fetchUpsellOptionsForDesktopAction, fetchUpsellOptionsForPackageUpsellForDesktopAction
} from '@upsell/store/actions/upsell.actions';
import { UpsellService } from '@upsell/services/upsell.service';
import { isNullOrUndefined } from '@app/util/util';
import { AvoService } from '@avo/services/avo.service';
import { PropertiesAmplitudeService } from '@app/services/properties-amplitude.service';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { UpsellAbstractEffects } from '@upsell/store/effects/upsell-abstract.effects';

@Injectable()
export class UpsellOptionEffects extends UpsellAbstractEffects {

  constructor(
    private readonly action$: Actions,
    private readonly service: UpsellService,
    protected translate: TranslocoService,
    protected avoService: AvoService,
    protected amplitudeService: PropertiesAmplitudeService,
  ) {
    super(translate, avoService, amplitudeService);
  }

  fetchFlightsOptionForUpsell$: Observable<unknown> = createEffect(() => this.action$
    .pipe(
      ofType(fetchOptionForUpsellAction),
      switchMap(action => iif(
        () => isNullOrUndefined(action.payload.OptionId),
        this.service.fetchFlightsOption(action.payload).pipe(map(result => result.OptionId)),
        of(action.payload.OptionId)
      ).pipe(
        map(optionId => fetchUpsellOptionsForDesktopAction({
          optionId: optionId,
          searchId: action.payload.SearchId,
          sessionToken: action.payload.SessionToken,
          airlineCode: action.payload.AirlineCode,
          flightKeys: action.payload.FlightKeys,
          isFlightUpsellTreatment: action.isFlightUpsellTreatment
        })),
        catchError((e) => this.getUpsellOptionError$(
          e, SearchBy.FLIGHTS
        ).pipe(take(1)))
      ))
    ));

  fetchFlightsOptionForPackageUpsellForDesktopAction$: Observable<unknown> = createEffect(() => this.action$
    .pipe(
      ofType(fetchFlightsOptionForPackageUpsellForDesktopAction),
      switchMap(action => iif(
        () => isNullOrUndefined(action.payload.OptionId),
        this.service.fetchPackageAirFlightsOption(action.payload).pipe(map(result => result.OptionId.toString())),
        of(action.payload.OptionId?.toString())
      ).pipe(
        map(optionId => fetchUpsellOptionsForPackageUpsellForDesktopAction({
          payload: { ...action.payload, AirlineCode: action.payload.AirlineCode },
          upsell: {
            ...action.upsell, optionIdAir: optionId,
            SearchId: action.payload.SearchId,
            SessionToken: action.payload.SessionToken,
          }
        })),
        catchError((e) => this.getUpsellOptionError$(
          e, SearchBy.PACKAGES
        ).pipe(take(1)))
      ))
    ));

  fetchFlightsOptionForPackageUpsell$: Observable<unknown> = createEffect(() => this.action$
    .pipe(
      ofType(fetchFlightsOptionForPackageUpsellAction),
      switchMap(action => this.service.fetchPackageAirFlightsOption(action.payload).pipe(
        map(result =>
          fetchPackageUpsellOptionsAction({
            payload: {
              ...action.upsell, optionIdAir:
                `${result.OptionId}`
            }
          })
        ),
        catchError((err) => this.getUpsellOptionError$(
          err, SearchBy.PACKAGES
        ).pipe(take(1)))
      ))
    )
  );

}
